import { Dispatch, FC, SetStateAction } from 'react'
import useAddressInput from '../../../hooks/useAddressInput'
import OneInputText from '../level_2/OneInputText'
import SelectInputText from '../level_2/SelectInputText'
import TowInputText from '../level_2/TowInputText'

export type AddressInputType = {
  address1: string
  setAddress1: Dispatch<SetStateAction<string>>
  address2: string
  setAddress2: Dispatch<SetStateAction<string>>
  city: string
  setCity: Dispatch<SetStateAction<string>>
  prefecture: string
  setPrefecture: Dispatch<SetStateAction<string>>
  postalCode: string
  setPostalCode: Dispatch<SetStateAction<string>>
  country: string
  setCountry: Dispatch<SetStateAction<string>>
}

const AddressInput: FC<AddressInputType> = (props) => {
  const {
    isJapan,
    countrySelect,
    prefectureSelect,
    prefectureInput,
    postalCodeInput,
    cityInput,
    address1Input,
    address2Input,
  } = useAddressInput(props)

  return (
    <div id="address">
      <label htmlFor="address1" className="d-block">
        住所:
      </label>
      <div className="stack m-0">
        <SelectInputText first={countrySelect} second={postalCodeInput} />
        {/* 日本のときは都道府県をプルダウン、日本以外のときは自由入力欄で表示する */}
        {isJapan ? (
          <SelectInputText first={prefectureSelect} second={cityInput} />
        ) : (
          <TowInputText first={prefectureInput} second={cityInput} />
        )}
        <OneInputText first={address1Input} />
        <OneInputText first={address2Input} />
      </div>
    </div>
  )
}

export default AddressInput
